import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DataVis4"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.25 2.25H3.75C2.92192 2.25083 2.25083 2.92192 2.25 3.75V20.25C2.25083 21.0781 2.92192 21.7492 3.75 21.75H20.25C21.0779 21.7488 21.7488 21.0779 21.75 20.25V3.75C21.7492 2.92192 21.0781 2.25083 20.25 2.25ZM20.25 6.75H12.75V3.75H20.25V6.75ZM11.25 20.25H8.25V17.25H11.25V20.25ZM11.25 15.75H8.25V12.75H11.25V15.75ZM6.75 15.75H3.75V12.75H6.75V15.75ZM8.25 11.25V8.25H15.75V11.25H8.25ZM8.25 6.75V3.75H11.25V6.75H8.25ZM17.25 8.25H20.25V11.25H17.25V8.25ZM6.75 3.75V11.25H3.75V3.75H6.75ZM3.75 17.25H6.75V20.25H3.75V17.25ZM12.75 20.25V12.75H20.2507L20.2515 20.25H12.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DataVis4.vue"]]);
